/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Oct 25 2023
 **/

import { FoldingB, useFoldingBHandler } from "@/frameworks/designStuff/components";

type FoldingBContentProps = {
	id: string;
	FoldingHeaderContent: React.ReactNode;
	FoldingBodyContent: React.ReactNode;
};
export default function SecondFoldingBContent({ id, FoldingHeaderContent, FoldingBodyContent }: FoldingBContentProps) {
	const { getFoldingBHeight, handleDebouncedHeight } = useFoldingBHandler();

	return (
		<FoldingB
			data-id={id}
			defaultData={{
				isOpen: true,
				draggable: true,
				upToTop: 60 + 56 + 52,
				height: getFoldingBHeight(id) || `${document.documentElement.clientHeight * 0.5 - 56}px`
			}}
			css={[
				{
					position: "absolute",
					overflow: "initial !important",
					bottom: "0px",
					width: "100%",
					background: "white",
					zIndex: 10
				}
			]}
			onChangeHeight={(height) => handleDebouncedHeight(id, height)}
		>
			<FoldingB.Header>{FoldingHeaderContent}</FoldingB.Header>
			<FoldingB.Body>{FoldingBodyContent}</FoldingB.Body>
		</FoldingB>
	);
}
